import { useEffect } from "react";
import { ModuleListItem } from "../../components/home/ModuleItem";
import { useOrganizationHook } from "../../hooks/useOrganizationHook";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useNavigate, useParams } from "react-router-dom";
import NavigatebackBtn from "../../components/generic/NavigateBackBtn";
import {    HRMmodules } from "../../constant/data";
import { CompanyItem } from "../../components/home/CompanyItem";
import { useModulesHook } from "../../hooks/useModulesHook";
import { employeeIcon, Moduleicon } from "../../constant/import";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import {
  dashboard,
  department,
  modularapp,
  NotificationIcon,
  settings,
} from "../../constant/import";


const SelectedOrgModules = () => {
  const { SelectedOrg, authuser } = useStateGetter();
  const navigate = useNavigate();
  const { orgid } = useParams();
  const { selectedOrgModules } = useOrganizationHook();
  const { allOrgModules } = useModulesHook();
  const { UserOrgs } = useOrganizationHook();
  const { setSelectedorg } = useStateSetter();
  useEffect(() => {
    setSelectedorg(UserOrgs.filter((jk: any) => jk.id == orgid)[0]);
  }, []);



  const CompanyItems = [
    { title: "Dashbaord", img: dashboard, path: "" },
    { title: "Report", img: dashboard, path: "" },
    // { title: "Department", img: department, path: "department" },
    { title: "Modular app", img: modularapp, path: `${orgid}/modularapps`},
  ];
  return (
    <div className="h-screen w-screen flex justify-center items-start  overflow-y-scroll  overflow-x-hidden">
      <div className=" px-20 flex relative justify-center flex-col items-center m-4  ">
        <div className={"absolute top-3 left-0"}>
          <NavigatebackBtn
            style={" ml-2   inline "}
            onclick={() => {  navigate(-1);   }}
          />
          <p className="ml-3 inline font-semibold ">{SelectedOrg?.orgName}</p>
        </div>

        <div className="grid grid-cols-4 gap-6  px-10  mt-10">
          {CompanyItems?.map(  (item: any) => !authuser.isEmployee && <CompanyItem item={item} />
          )}
          {allOrgModules.map((item: any) => (
            <div
              onClick={() => {
                // navigate to the selected module  TODO change test to actual module id
                if (item.moduleUID == "EMP") {
                  navigate(`/home/${orgid}/modules/Employee`);
                }

                else if(item.moduleUID == "CRM"){
                  navigate(`/home/${orgid}/modules/CRM`);

                }
              }}
              className="bg-white shadow-sm rounded-[10px] border border-customGray p-4 flex flex-col justify-center items-center"
            >
              <img
                src={
                  item.moduleName.includes("Employee")
                    ? employeeIcon
                    : Moduleicon
                }
              />

              <p className="font-medium mt-2 text-textbg text-xs  cursor-pointer text-center ">
                {item.moduleName}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-4 gap-6  px-10 pb-20   mt-10">
          {/* {HRMmodules.map((item: any) => (
            <div
              onClick={() => {
                // navigate to the selected module  TODO change test to actual module id
                navigate(`/home/modules/${item.moduleUID}`);
              }}
              className="bg-white shadow-sm rounded-[10px] border border-customGray p-4 flex flex-col justify-center items-center"
            >
              <img src={Moduleicon} />

              <p className="font-medium mt-2 text-textbg text-xs  cursor-pointer text-center ">
                {item.moduleName}
              </p>
            </div>
          ))} */}
        </div>
      </div>
    </div>
  );
};

export { SelectedOrgModules };
